const animation = {
  "ani_01_title": "<span>Perpaduan </span> <span><em>seni, sains, </em></span> <span>dan </span> <span><em>inovasi</em></span>",
  "ani_01_content": "Dirancang secara ilmiah dan dibuat dengan sentuhan seni artistik untuk keserasian dengan mata. Kreasikan kecantikanmu dengan Deﬁne®.",

  "ani_02_title": "<span><em>Teknologi Lacreon®</em></span> <span>yang canggih </span> <span> dan terkini</span>",
  "ani_02_content": "Didesain untuk menjaga kelembapan dan mencegah iritasi agar nyaman sepanjang hari.",

  "ani_03_title": "<span>Desain tepi </span> <span><em>super tipis, </em></span> <span>nyaris tak terlihat</span>",
  "ani_03_content": "Tepi lensa tipis meruncing sehingga kelopak mata bisa bergerak mulus tanpa rasa terganjal.",

  "ani_04_title": "<span><em>Kredibilitas </em></span> <span><em>berbasis sains </em></span> <span>yang bisa kamu percaya</span>",
  "ani_04_content": "Nikmati lensa kontak berkualitas yang dirancang untuk kenyamanan dan keamanan maksimal.",
}

export default animation


